// extracted by mini-css-extract-plugin
module.exports = {"userCard":"SelectOrganization_userCard__qbCGS"};